import React from "react"
import {Trans} from "react-i18next"

import {AActivityFeed, AProspectActivity} from "../../../../../services/types.generated.ts"
import {commonTransComponents} from "../../../../../utils/i18n.tsx"

export const ActivityBodyCall: React.FC<{activity: AActivityFeed | AProspectActivity}> = ({activity}) => {
  return (
    <div>
      <Trans
        i18nKey={"SellingDetails_News_ActivityFeed_Call"}
        components={commonTransComponents}
        count={"grouped_count" in activity ? activity.grouped_count : 1}
      />
    </div>
  )
}
